export default __webpack_public_path__ + "static/media/verified_Visa.f5d1e591.png";